import React from "react";
import { countries } from "../../utils/countries";

const CountryOptions = () => {
  return (
    <React.Fragment>
      {countries.map((item, index) => {
        return (
          <option translate="no" key={item.code} value={item.code}>
            {item.name}
          </option>
        );
      })}
    </React.Fragment>
  );
};

export default CountryOptions;
